import { AuthProvider } from '@praxis/component-auth'
import { EnvProvider } from '@praxis/component-runtime-env'
import { BrowserRouter } from 'react-router-dom'
import apiConfig from './shared/config/apiConfig'
import AppAuthentication from './shared/authentication/components/AppAuthentication'

const App = () => {
  return (
    <EnvProvider
      commonConfig={apiConfig}
      configPath={
        process.env.NODE_ENV === 'development'
          ? '/config.json'
          : '/app-environment'
      }
    >
      <AuthProvider {...apiConfig.auth}>
        <BrowserRouter>
          <AppAuthentication />
        </BrowserRouter>
      </AuthProvider>
    </EnvProvider>
  )
}
export default App
